enum DividasStoreError {
  DIVIDA_ID_NAO_ENCONTRADA,
  UPDATE_ID_NAO_COINCIDE,
  CREATE_ID_EXISTENTE,
  OFERTA_NAO_ENCONTRADA,
}

export default DividasStoreError;
